/**
 * PC_EIF_01 importing the api function calls and required functions from the components.
 */
import { useState, useEffect } from "react";
import React from "react";
import { postEmployeePrimaryInfo, getEmployeePrimaryInfo, getMaritalStatus, getHrList, getEmploymentType, getNotificationId } from "../service/DirectorAPI";
import { NotificationTrigger } from '../utils/RegHandling';
import moment from "moment";
import { useRef } from "react";
import $ from 'jquery';
import { connect } from 'react-redux';
import { encryptStorage } from '../constant'

/**
 * 
 * PC_EIF_02 EmployeeInfo function contains the variables and return the HTML
 */
function EmployeeInfo(props) {
        const [DisableSubmitBtn, setDisableSubmitBtn] = useState(false);


    /**
     * PC_EIF_02 Declaring the State variables,arrays and objects
     */
    let dataObj = {
        id: "",
        HrIncharge: "",
        EmploymentType: "select",
        PersonalEmailId: "",
        MaritalStatus: "select",
        AnniversaryDate: "",
        AadharCardNum: "",
        PanCardNum: "",
        PhoneNum: "",
        AlternateNum: "",
        EmergencyContactNum: ""
    };

    const [EmployeeInfoData, setEmployeeInfoData] = useState(dataObj);


    let oldvalue = {
        HrIncharge: "",
        EmploymentType: "",
        PersonalEmailId: "",
        MaritalStatus: "selected",
        AnniversaryDate: "",
        AadharCardNum: "",
        PanCardNum: "",
        PhoneNum: "",
        AlternateNum: "",
        EmergencyContactNum: ""
    }

    let validationFields = {
        HrIncharge: "",
        EmploymentType: "",
        PersonalEmailId: "",
        MaritalStatus: "",
        AnniversaryDate: "",
        AadharCardNum: "",
        PanCardNum: "",
        PhoneNum: "",
        AlternateNum: "",
        EmergencyContactNum: ""

    }

    const [Oldvalue, setOldvalue] = useState(oldvalue);
    const [message, setmessage] = useState(validationFields);
    const [EmpId, setEmpId] = useState("");
    const [notification, setNotification] = useState([]);
    const aadhar = useRef();

    let editMaritalStatus = [];
    let dropDownArrayMaritalStatus = [];
    const [arrDropDownmaritalstatus, setarrDropDownmaritalstatus] = useState(dropDownArrayMaritalStatus);

    let dropDownArrayHr = [];
    const [arrDropDownhr, setarrDropDownhr] = useState(dropDownArrayHr);

    let dropDownEmploymenttype = [];
    const [employmenttype, setarrDropDownEmploymenttype] = useState(dropDownEmploymenttype);

    let [hideForm, setHideForm] = useState(true);

    let loginEmpId = encryptStorage.getItem("employeeId");
    let role = encryptStorage.getItem("role");

    const [hideAnniversaryDateField, setHideAnniversaryDateField] = useState(false);
    const [sourceMaritalStatus, setsourceMaritalStatus] = useState('');
    const [reportstoId, setReportstoId] = useState("");


    /**
     * PC_EIF_03  useEffect method get invocked make a api calls and set the values into the variabeles
     * remove the browser scroll bar
     */
    useEffect(() => {
        setDisableSubmitBtn(false)
        if (props.isEmpPrimaryClick) {

            $("body").addClass("removeScroll");
            LoadMaritalStatus();
            //LoadHrList();
            LoadHr();
            LoadEmploymenttype()
            setHideForm(props.hideEmployeeInfoForm);

            if (props.empId != undefined) {
                setEmpId(props.empId)
            }
            if (props.empId != undefined) {

                let objedit = {
                    emp_id: props.empId,
                    reports_to: loginEmpId,
                    role: role,
                };

                selecteditarray(objedit);
            }
        }

    }, [props])

    let rejexvalidation = {
        PersonalEmailId: "",
        PhoneNumber: "",
        AlternateNum: "",
        EmergencyContactNum: "",
        AadharCardNum: "",
        PanCardNum: ""

    }
    const [rejexMessage, setRejexMessage] = useState(rejexvalidation);

    /**
     * PC_EIF_13 this function will set the values into the state variables
     * and also validate the rejex validation
     */
    const OnChangeName = (e) => {
        setDisableSubmitBtn(true);
        
        e.preventDefault();
        let regexItem;
        let checkValid;

        if (e.target.name == "PhoneNum") {
            regexItem = new RegExp("^[0-9]*$");
            checkValid = regexItem.test(e.target.value);
            if (checkValid == false) {
                rejexMessage.PhoneNumber = "Enter a Valid Phone Number"
                setRejexMessage({ ...rejexMessage });

            } else {
                rejexMessage.PhoneNumber = ""
                setRejexMessage({ ...rejexMessage });
            }
        }

        if (e.target.name == "AlternateNum") {
            regexItem = new RegExp("^[0-9]*$");
            checkValid = regexItem.test(e.target.value);
            if (checkValid == false) {
                rejexMessage.AlternateNum = "Enter a Valid Alternate Number"
                setRejexMessage({ ...rejexMessage });

            } else {
                rejexMessage.AlternateNum = ""
                setRejexMessage({ ...rejexMessage });
            }
        }

        if (e.target.name == "EmergencyContactNum") {
            regexItem = new RegExp("^[0-9]*$");
            checkValid = regexItem.test(e.target.value);
            if (checkValid == false) {
                rejexMessage.EmergencyContactNum = "Enter a Valid Emergency Contact Number"
                setRejexMessage({ ...rejexMessage });

            } else {
                rejexMessage.EmergencyContactNum = ""
                setRejexMessage({ ...rejexMessage });
            }
        }

        if (e.target.name == "PanCardNum") {
            regexItem = new RegExp("^[a-zA-Z0-9]*$");
            checkValid = regexItem.test(e.target.value);
            if (checkValid == false) {
                rejexMessage.PanCardNum = "Enter a Valid Pan Card Number"
                setRejexMessage({ ...rejexMessage });

            } else {
                rejexMessage.PanCardNum = ""
                setRejexMessage({ ...rejexMessage });
            }
        }

        if (e.target.name == "PersonalEmailId") {
            regexItem = new RegExp("^[a-zA-Z0-9.]+@[a-zA-Z0-9.-]+[a-zA-Z]{2,}$")
            checkValid = regexItem.test(e.target.value);
            if (checkValid == false) {
                rejexMessage.PersonalEmailId = "Enter valid email id"
                setRejexMessage({ ...rejexMessage });

            } else {
                rejexMessage.PersonalEmailId = ""
                setRejexMessage({ ...rejexMessage });
            }
        }

        if (e.target.name == "AadharCardNum" && e.target.value != "") {
            regexItem = new RegExp("^[0-9]{12}$");
            checkValid = regexItem.test(e.target.value);
            if (checkValid == false) {
                rejexMessage.AadharCardNum = "Enter valid aadhar number"
                setRejexMessage({ ...rejexMessage });

            } else {
                rejexMessage.AadharCardNum = ""
                setRejexMessage({ ...rejexMessage });
            }
        } else {
            rejexMessage.AadharCardNum = ""
            setRejexMessage({ ...rejexMessage });
        }

        setEmployeeInfoData({ ...EmployeeInfoData, [e.target.name]: e.target.value });
        setmessage({ ...message, [e.target.name]: "" });

        if (e.target.name == "MaritalStatus") {
            let CheckMaritalStatus = arrDropDownmaritalstatus.filter((status) => status.id == e.target.value).map(el => {
                return el.name;
            })[0]
            setsourceMaritalStatus(CheckMaritalStatus)


            if (CheckMaritalStatus == "Unmarried" || CheckMaritalStatus == "UnMarried" || e.target.value == "select") {
                setHideAnniversaryDateField(false);
            }
            else {
                setHideAnniversaryDateField(true);
            }
        }
        setDisableSubmitBtn(false);

    };

    // const LoadHrList = async (value) => {

    //     let EducationData = {};
    //     let responsedata = await getHrList(EducationData);
    //     let temparray = responsedata.data.ResponseData[0]
    //     let samplearray = [];

    //     for (let i = 0; i <= temparray.length - 1; i++) {
    //         let objresponse = {
    //             value: temparray[i].emp_id,
    //             label: temparray[i].emp_name
    //         }
    //         samplearray.push(objresponse);
    //     }

    // }

    /**
     * PC_EIF_14 this function will validate the state variable has a 
     * value or not befor post into the api and set the error message
     */
    const validation = () => {

        

        if (role != "Team Member" && loginEmpId != EmpId && (EmployeeInfoData.HrIncharge.trim() == "" || EmployeeInfoData.HrIncharge == "select")) {

            message.HrIncharge = "HR in-charge is required"
            setmessage({ ...message });
        } else {
            message.HrIncharge = ""
            setmessage({ ...message });

        }
        if (EmployeeInfoData.EmploymentType.trim() == "" || EmployeeInfoData.EmploymentType == "select") {

            message.EmploymentType = "Employment type is required"
            setmessage({ ...message });

        } else {
            message.EmploymentType = ""
            setmessage({ ...message });

        }

        if (EmployeeInfoData.PersonalEmailId.trim() == "") {

            message.PersonalEmailId = "Personal email id is required"
            setmessage({ ...message });

        } else {
            message.PersonalEmailId = ""
            setmessage({ ...message });

        }
        if (EmployeeInfoData.MaritalStatus == "select") {

            message.MaritalStatus = "Marital status is required"
            setmessage({ ...message });

        } else {
            message.MaritalStatus = ""
            setmessage({ ...message });

        }
        if (EmployeeInfoData.AnniversaryDate == "Invalid date" || EmployeeInfoData.AnniversaryDate.trim() == "" && (sourceMaritalStatus != "UnMarried" && sourceMaritalStatus != "Unmarried")) {

            message.AnniversaryDate = "Anniversary Date is required"
            setmessage({ ...message });

        } else {
            message.AnniversaryDate = ""
            setmessage({ ...message });

        }
        if (EmployeeInfoData.AadharCardNum.trim() == "") {

            message.AadharCardNum = "Aadhar Card Number is required"
            setmessage({ ...message });

        } else {
            message.AadharCardNum = ""
            setmessage({ ...message });

        }
        if (EmployeeInfoData.PanCardNum.trim() == "") {

            message.PanCardNum = "Pan Card Number is required"
            setmessage({ ...message });

        } else {
            message.PanCardNum = ""
            setmessage({ ...message });

        }
        if (EmployeeInfoData.PhoneNum.trim() == "") {

            message.PhoneNum = "Phone Number is required"
            setmessage({ ...message });

        } else {
            message.PhoneNum = ""
            setmessage({ ...message });

        }
        if (EmployeeInfoData.AlternateNum.trim() == "") {

            message.AlternateNum = "Alternate Number is required"
            setmessage({ ...message });

        } else {
            message.AlternateNum = ""
            setmessage({ ...message });

        }

        if (EmployeeInfoData.EmergencyContactNum.trim() == "") {

            message.EmergencyContactNum = "Emergency Contact Number is required"
            setmessage({ ...message });

        } else {
            message.EmergencyContactNum = ""
            setmessage({ ...message });

        }

    }

    /**
     * PC_EIF_05.1 this function will get the marital status from the database
     */

    const LoadMaritalStatus = async () => {
        let EducationData = {};
        let responsedata = await getMaritalStatus(EducationData);
        setarrDropDownmaritalstatus(responsedata.data.ResponseData[0]);
        editMaritalStatus.push(responsedata.data.ResponseData[0]);
    };

    /**
     * PC_EIF_05.1 this function will get the hr list from the database
     */
    const LoadHr = async () => {
        let EducationData = {};
        let responsedata = await getHrList(EducationData);
        setarrDropDownhr(responsedata.data.ResponseData[0]);
    };

    /**
     * PC_EIF_05.2 this function will get the employment type data from the database
     */
    const LoadEmploymenttype = async () => {
        let EmploymentData = {};
        let responsedata = await getEmploymentType(EmploymentData);
        setarrDropDownEmploymenttype(responsedata.data.ResponseData[0]);
    };

    /**
     * PC_EIF_12.1 this function will return the values into the drop down values
     */

    const buildMaritalStatus = () => {
        return arrDropDownmaritalstatus.map((value, index) => {
            return <option value={value.id} id={value.name}>{value.name}</option>;
        });
    };

    /**
     * PC_EIF_12.1 this function will return the values into the drop down values
     */
    const buildHr = () => {
        return arrDropDownhr.map((value, index) => {
            return <option value={value.emp_id}>{value.emp_name}</option>;
        });
    };

    /**
     * PC_EIF_12.1 this function will return the values into the drop down values
     */
    const buildEmploymenttype = () => {
        return employmenttype.map((value, index) => {
            return <option value={value.employment_type}>{value.employment_type}</option>;
        });
    };

    /**
     * PC_EIF_22 this function will clear the all state variables values
     */
    const cancelClick = () => {
        
        let valiclearoption = {
            id: "",
            HrIncharge: "",
            EmploymentType: "",
            PersonalEmailId: "",
            MaritalStatus: "selected",
            AnniversaryDate: "",
            AadharCardNum: "",
            PanCardNum: "",
            PhoneNum: "",
            AlternateNum: "",
            EmergencyContactNum: ""
        };
        setEmployeeInfoData(valiclearoption);

        let validationFields = {
            HrIncharge: "",
            EmploymentType: "",
            PersonalEmailId: "",
            MaritalStatus: "",
            AnniversaryDate: "",
            AadharCardNum: "",
            PanCardNum: "",
            PhoneNum: "",
            AlternateNum: "",
            EmergencyContactNum: ""

        }
        setmessage(validationFields);

        let rejexvalidation = {
            PersonalEmailId: "",
            PhoneNumber: "",
            AlternateNum: "",
            EmergencyContactNum: "",
            AadharCardNum: "",
            PanCardNum: ""

        }
        setRejexMessage(rejexvalidation);
        props.setIsEmpPrimaryClicked(false);
        setHideForm(true);
        props.setHideEmployeeInfoForm(true);
        $("body").removeClass("removeScroll");

    }


    /**
     * PC_EIF_15 this function will post the data into the database and send the notification
     */
    const submitClick = async () => {
        
        try {
            setDisableSubmitBtn(true);
            validation();

            let isRejexValid = true;

            if (rejexMessage.PhoneNumber != "" || rejexMessage.AlternateNum != "" || rejexMessage.EmergencyContactNum != "" || rejexMessage.PanCardNum != "" || rejexMessage.PersonalEmailId != "" || rejexMessage.AadharCardNum != "") {
                isRejexValid = false;
            }

            if (sourceMaritalStatus != "Unmarried" && sourceMaritalStatus != "UnMarried" && sourceMaritalStatus != "" && (EmployeeInfoData.AnniversaryDate == "" || EmployeeInfoData.AnniversaryDate == "select")) {
                isRejexValid = false;
            }

            if ((((role == "Hr Manager" || role == "Hr") && loginEmpId != EmpId) || (role == "Hr Manager" && loginEmpId == EmpId && reportstoId == loginEmpId)) && isRejexValid == true) {
                if (
                    EmployeeInfoData.HrIncharge != "" &&
                    EmployeeInfoData.EmploymentType != "" &&
                    EmployeeInfoData.EmploymentType != "select" &&
                    EmployeeInfoData.PersonalEmailId != "" &&
                    EmployeeInfoData.MaritalStatus != "" && EmployeeInfoData.MaritalStatus != "select" &&
                    //EmployeeInfoData.AnniversaryDate != "" &&
                    EmployeeInfoData.AadharCardNum != "" &&
                    EmployeeInfoData.PanCardNum != "" &&
                    EmployeeInfoData.PhoneNum != "" &&
                    EmployeeInfoData.AlternateNum != "" &&
                    EmployeeInfoData.EmergencyContactNum != ""
                ) {
                    let updatedata = {
                        request_type: "Update",
                        emp_id: EmpId,
                        login_emp_id: loginEmpId,
                        role: role,
                        id: EmployeeInfoData.id,
                        employment_type: EmployeeInfoData.EmploymentType,
                        Personal_email: EmployeeInfoData.PersonalEmailId,
                        hr_incharge: EmployeeInfoData.HrIncharge,
                        marital_status_id: EmployeeInfoData.MaritalStatus,
                        anniversary_date: sourceMaritalStatus == "Unmarried" || sourceMaritalStatus == "UnMarried" || sourceMaritalStatus == "" ? "01-01-1800" : EmployeeInfoData.AnniversaryDate,
                        aadhar_num: EmployeeInfoData.AadharCardNum,
                        Pan_card_num: EmployeeInfoData.PanCardNum,
                        alternate_num: EmployeeInfoData.AlternateNum,
                        emergency_num: EmployeeInfoData.EmergencyContactNum,
                        phone_num: EmployeeInfoData.PhoneNum

                    };

                    let responsedata = await postEmployeePrimaryInfo(updatedata);
                    if (responsedata.data.status == 200) {

                        cancelClick();
                        props.setHideToast('Updated', 'Updated Succesfully');
                        props.setIsEmpPrimaryClicked(false);

                        let EmployeeData = {
                            emp_id: props.empId,
                            role: role,
                        };
                        props.getEmpPrimaryDetails(EmployeeData);
                    }
                }


            } else if ((role == "Team Member" || loginEmpId == EmpId) && isRejexValid == true) {
                if (
                    //EmployeeInfoData.HrIncharge != "" &&
                    EmployeeInfoData.EmploymentType != "" &&
                    EmployeeInfoData.EmploymentType != "select" &&
                    EmployeeInfoData.PersonalEmailId != "" &&
                    EmployeeInfoData.MaritalStatus != "" && EmployeeInfoData.MaritalStatus != "select" &&
                    //EmployeeInfoData.AnniversaryDate != "" &&
                    EmployeeInfoData.AadharCardNum != "" &&
                    EmployeeInfoData.PanCardNum != "" &&
                    EmployeeInfoData.PhoneNum != "" &&
                    EmployeeInfoData.AlternateNum != "" &&
                    EmployeeInfoData.EmergencyContactNum != ""
                ) {

                    let newvalue = {
                        employment_type: EmployeeInfoData.EmploymentType,
                        Personal_email: EmployeeInfoData.PersonalEmailId,
                        hr_incharge: EmployeeInfoData.HrIncharge,
                        marital_status_id: EmployeeInfoData.MaritalStatus,
                        anniversary_date: sourceMaritalStatus == "Unmarried" || sourceMaritalStatus == "UnMarried" || sourceMaritalStatus == "" ? "01-01-1800" : EmployeeInfoData.AnniversaryDate,
                        aadhar_num: EmployeeInfoData.AadharCardNum,
                        Pan_card_num: EmployeeInfoData.PanCardNum,
                        alternate_num: EmployeeInfoData.AlternateNum,
                        emergency_num: EmployeeInfoData.EmergencyContactNum,
                        phone_num: EmployeeInfoData.PhoneNum
                    }

                    let oldvalue = {
                        employment_type: Oldvalue.EmploymentType ? Oldvalue.EmploymentType : "",
                        Personal_email: Oldvalue.PersonalEmailId ? Oldvalue.PersonalEmailId : "",
                        hr_incharge: Oldvalue.HrIncharge ? Oldvalue.HrIncharge : "",
                        marital_status_id: Oldvalue.MaritalStatus == 'selected' || Oldvalue.MaritalStatus == undefined ? '' : Oldvalue.MaritalStatus,
                        anniversary_date: Oldvalue.AnniversaryDate == "" || Oldvalue.AnniversaryDate == 'Invalid date' ? "01-01-1800" : Oldvalue.AnniversaryDate,
                        aadhar_num: Oldvalue.AadharCardNum ? Oldvalue.AadharCardNum : "",
                        Pan_card_num: Oldvalue.PanCardNum ? Oldvalue.PanCardNum : "",
                        alternate_num: Oldvalue.AlternateNum ? Oldvalue.AlternateNum : "",
                        emergency_num: Oldvalue.EmergencyContactNum ? Oldvalue.EmergencyContactNum : "",
                        phone_num: Oldvalue.PhoneNum ? Oldvalue.PhoneNum : ""
                    }

                    let NewValue = Object.keys(newvalue);
                    let OldValue = Object.keys(oldvalue);

                    let log_data = '{';
                    for (let i = 0; i <= NewValue.length; i++) {
                        if (newvalue[NewValue[i]] != oldvalue[OldValue[i]] && NewValue[i] != "hr_incharge") {

                            log_data += '"' + NewValue[i] + '"' + ':' + '"' + "'" + newvalue[NewValue[i]] + "'" + ',' + "'" + oldvalue[OldValue[i]] + "'" + '"' + ',';
                        }
                        if (i == NewValue.length) {

                            log_data = log_data.slice(0, -1);
                            log_data = log_data + "}";
                        }
                    }

                    if (log_data != '{' && log_data != '}') {
                        let logData = JSON.parse(log_data);

                        let updatedata = {
                            request_type: "Update",
                            emp_id: EmpId,
                            login_emp_id: loginEmpId,
                            category_id: "0",
                            category: "emp_primary_info",
                            status: "Pending",
                            role: "Team Member",
                            log_data: logData

                        };

                        

                        let emp = [];
                        notification.map((obj, index) => {

                            emp.push(obj.emp_id);
                        });

                        if (Object.keys(logData).length > 0) {

                            let responsedata = await postEmployeePrimaryInfo(updatedata);
                            if (responsedata.data.status == 200) {

                                let profileRequestId = responsedata.data.ResponseData[1];
                                await NotificationTrigger({ title: "Profile Update", message: 'Profile Request', route: '/profileupdate', state: { state: { profileRequestId: profileRequestId } }, to_employee: emp, by: loginEmpId }, emp, props.websocket)

                                cancelClick();
                                props.setHideToast('Profile Request submitted', 'Changes will be reflected after the approval');
                                props.setIsEmpPrimaryClicked(false);
                            }
                        }
                    } else { cancelClick(); }
                    
                }
            }
            setDisableSubmitBtn(false);

        } catch (e) {
            setDisableSubmitBtn(false);

        }
    }

    /**
     * 
     * PC_EIF_06 this function will get the data and store it into the stata variable
     */
    const selecteditarray = async (objedit) => {
        
        try {
            let responsedata = await getEmployeePrimaryInfo(objedit);

            
            if (responsedata.data != undefined && responsedata.data != null && responsedata.data.ResponseData != null) {

                let maritalResponse = await getMaritalStatus({});
                //let status = "";
                let status = maritalResponse.data.ResponseData[0]?.filter((status) => status.id == responsedata?.data?.ResponseData[0][0]?.marital_status_id).map(el => {
                    return el.name;
                });
                setsourceMaritalStatus(status);

                let anniversaryDate = moment(new Date(responsedata?.data?.ResponseData[0][0]?.anniversary_date));
                let oldAnniversaryDate = status == "Unmarried" || status == "UnMarried" ? "" : anniversaryDate.format("YYYY-MM-DD");

                if (status == "Unmarried" || status == "UnMarried") {
                    setHideAnniversaryDateField(false);
                }
                else {
                    setHideAnniversaryDateField(true);
                }

                let oldvalueobj = {

                    HrIncharge: responsedata?.data?.ResponseData[0][0]?.hr_inchargeid,
                    EmploymentType: responsedata?.data?.ResponseData[0][0]?.employment_type,
                    PersonalEmailId: responsedata?.data?.ResponseData[0][0]?.personal_email,
                    MaritalStatus: responsedata?.data?.ResponseData[0][0]?.marital_status_id,
                    AnniversaryDate: oldAnniversaryDate,
                    AadharCardNum: responsedata?.data?.ResponseData[0][0]?.aadhar_num,
                    PanCardNum: responsedata?.data?.ResponseData[0][0]?.pan_card_num,
                    PhoneNum: responsedata?.data?.ResponseData[0][0]?.phone_num,
                    AlternateNum: responsedata?.data?.ResponseData[0][0]?.alternate_num,
                    EmergencyContactNum: responsedata?.data?.ResponseData[0][0]?.emergency_num
                };
                setOldvalue(oldvalueobj);


                let newAnniversaryDate = status == "Unmarried" || status == "UnMarried" ? "" : anniversaryDate.format("YYYY-MM-DD");


                let valiDateobj1 = {
                    id: responsedata?.data?.ResponseData[0][0]?.id || "",
                    HrIncharge: responsedata?.data?.ResponseData[0][0]?.hr_inchargeid || "",
                    EmploymentType: responsedata?.data?.ResponseData[0][0]?.employment_type || "",
                    PersonalEmailId: responsedata?.data?.ResponseData[0][0]?.personal_email || "",
                    MaritalStatus: responsedata?.data?.ResponseData[0][0]?.marital_status_id || "select",
                    AnniversaryDate: newAnniversaryDate ? newAnniversaryDate : "",
                    AadharCardNum: responsedata?.data?.ResponseData[0][0]?.aadhar_num || "",
                    PanCardNum: responsedata?.data?.ResponseData[0][0]?.pan_card_num || "",
                    PhoneNum: responsedata?.data?.ResponseData[0][0]?.phone_num || "",
                    AlternateNum: responsedata?.data?.ResponseData[0][0]?.alternate_num || "",
                    EmergencyContactNum: responsedata?.data?.ResponseData[0][0]?.emergency_num || ""

                };
                setEmployeeInfoData(valiDateobj1);

            }
            
            let NotaficationData = await getNotificationId(objedit);
            setNotification(NotaficationData.data.ResponseData[0]);
            setReportstoId(NotaficationData?.data?.ResponseData[0][0]?.emp_id);


        } catch (e) {

        }
    };

    return (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.6)' }} hidden={hideForm}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header border-0">
                        <h5 className="modal-title profile-popup-header" id="employeeinfoLabel">
                            Team Member Info
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => cancelClick()}
                        />
                    </div>
                    <div className="employeeInfoScroll">
                        <div className="modal-body">
                            <div className="row mb-4">
                                <div className="col-md-6">
                                    <label htmlFor="dependant-HR-in-charge" className="form-label hive-form-label">
                                        HR in-charge<span className="hive-form-mandatory">*</span>
                                    </label>

                                    <select
                                        className="form-select hive-form-select "
                                        style={{ height: '40PX' }}
                                        aria-label="Default select example"
                                        id="dependant-marital-status"
                                        name="HrIncharge"
                                        value={EmployeeInfoData.HrIncharge}
                                        onChange={(e) => {
                                            OnChangeName(e);
                                        }}
                                        disabled={role == 'Team Member' || loginEmpId == EmpId ? true : false}
                                    >
                                        <option value="">select</option>
                                        {buildHr()}
                                    </select>
                                    {message.HrIncharge ? <label className="hive-form-mandatory">{message.HrIncharge}</label> : null}
                                </div>

                                <div className="col-md-6">
                                    <label htmlFor="dependant-employment-type" className="form-label hive-form-label">
                                        Employment Type<span className="hive-form-mandatory">*</span>
                                    </label>
                                    <select
                                        className="form-select hive-form-select"
                                        aria-label="Default select example"
                                        id="dependant-employment-type"
                                        name="EmploymentType"
                                        value={EmployeeInfoData.EmploymentType}
                                        onChange={(e) => {
                                            OnChangeName(e);
                                        }}
                                    >
                                        <option value="select">select</option>
                                        {buildEmploymenttype()}
                                    </select>
                                    {message.EmploymentType ? (
                                        <label className="hive-form-mandatory">{message.EmploymentType}</label>
                                    ) : null}
                                </div>
                            </div>
                            <div className="row mb-2">
                                <h1 className="profile-popup-subheader">Primary Info</h1>
                                <div className="col-md-6 mb-4">
                                    <label htmlFor="dependant-personal-email" className="form-label hive-form-label">
                                        Personal Email ID<span className="hive-form-mandatory">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control hive-form-control"
                                        id="dependant-personal-email"
                                        aria-describedby="Personal Email"
                                        placeholder="Enter here"
                                        maxLength={320}
                                        name="PersonalEmailId"
                                        value={EmployeeInfoData.PersonalEmailId}
                                        onChange={(e) => {
                                            OnChangeName(e);

                                        }}
                                    />
                                    {message.PersonalEmailId ? (
                                        <label className="hive-form-mandatory">{message.PersonalEmailId}</label>
                                    ) : null}
                                    {rejexMessage.PersonalEmailId ? (
                                        <label className="hive-form-mandatory">{rejexMessage.PersonalEmailId}</label>
                                    ) : null}
                                </div>
                                <div className="col-md-6 mb-4">
                                    <label htmlFor="dependant-marital-status" className="form-label hive-form-label">
                                        Marital Status<span className="hive-form-mandatory">*</span>
                                    </label>
                                    <select
                                        className="form-select hive-form-select"
                                        aria-label="Default select example"
                                        id="dependant-marital-status"
                                        name="MaritalStatus"
                                        value={EmployeeInfoData.MaritalStatus}
                                        onChange={(e) => {
                                            OnChangeName(e);
                                        }}
                                    >
                                        <option value="select">select</option>
                                        {buildMaritalStatus()}
                                    </select>
                                    {message.MaritalStatus ? <label className="hive-form-mandatory">{message.MaritalStatus}</label> : null}
                                </div>
                                {hideAnniversaryDateField ? (
                                    <div className="col-md-6 mb-4">
                                        <label htmlFor="dependant-anniversary-date" className="form-label hive-form-label">
                                            Anniversary Date<span className="hive-form-mandatory">*</span>
                                        </label>
                                        <input
                                            type="date"
                                            className="form-control hive-form-control"
                                            id="dependant-anniversary-date"
                                            aria-describedby="Anniversary Date"
                                            name="AnniversaryDate"
                                            value={EmployeeInfoData.AnniversaryDate}
                                            onChange={(e) => {
                                                OnChangeName(e);
                                            }}
                                        />
                                        {message.AnniversaryDate ? (
                                            <label className="hive-form-mandatory">{message.AnniversaryDate}</label>
                                        ) : null}
                                    </div>
                                ) : null}
                                <div className="col-md-6 mb-4">
                                    <label htmlFor="dependant-aadhaar-card" className="form-label hive-form-label">
                                        Aadhaar Card<span className="hive-form-mandatory">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control hive-form-control"
                                        id="dependant-aadhaar-card"
                                        aria-describedby="Aadhaar Card"
                                        placeholder="Enter here"
                                        ref={aadhar}
                                        maxLength={12}
                                        name="AadharCardNum"
                                        value={EmployeeInfoData.AadharCardNum}
                                        onChange={(e) => {
                                            OnChangeName(e);
                                        }}
                                    />
                                    {message.AadharCardNum ? <label className="hive-form-mandatory">{message.AadharCardNum}</label> : null}
                                    {rejexMessage.AadharCardNum ? (
                                        <label className="hive-form-mandatory">{rejexMessage.AadharCardNum}</label>
                                    ) : null}
                                </div>
                                <div className="col-md-6 mb-4">
                                    <label htmlFor="dependant-pancard" className="form-label hive-form-label">
                                        PAN Card<span className="hive-form-mandatory">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control hive-form-control"
                                        id="dependant-pancard"
                                        aria-describedby="PAN Card"
                                        placeholder="Enter here"
                                        maxLength={10}
                                        name="PanCardNum"
                                        value={EmployeeInfoData.PanCardNum}
                                        onChange={(e) => {
                                            OnChangeName(e);
                                        }}
                                    />
                                    {message.PanCardNum ? <label className="hive-form-mandatory">{message.PanCardNum}</label> : null}
                                    {rejexMessage.PanCardNum ? (
                                        <label className="hive-form-mandatory">{rejexMessage.PanCardNum}</label>
                                    ) : null}
                                </div>
                            </div>
                            <div className="row mb-2">
                                <h1 className="profile-popup-subheader">Contact Info</h1>
                                <div className="col-md-6 mb-4">
                                    <label htmlFor="dependant-phone-number" className="form-label hive-form-label">
                                        Phone Number<span className="hive-form-mandatory">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control hive-form-control"
                                        id="dependant-phone-number"
                                        aria-describedby="Phone Number"
                                        placeholder="Enter here"
                                        maxLength={10}
                                        name="PhoneNum"
                                        value={EmployeeInfoData.PhoneNum}
                                        onChange={(e) => {
                                            OnChangeName(e);
                                        }}
                                    />
                                    {message.PhoneNum ? <label className="hive-form-mandatory">{message.PhoneNum}</label> : null}
                                    {rejexMessage.PhoneNumber ? (
                                        <label className="hive-form-mandatory">{rejexMessage.PhoneNumber}</label>
                                    ) : null}
                                </div>
                                <div className="col-md-6 mb-4">
                                    <label htmlFor="dependant-alternate-number" className="form-label hive-form-label">
                                        Alternate Number<span className="hive-form-mandatory">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control hive-form-control"
                                        id="dependant-alternate-number"
                                        aria-describedby="Alternate Contact Number"
                                        placeholder="Enter here"
                                        maxLength={10}
                                        name="AlternateNum"
                                        value={EmployeeInfoData.AlternateNum}
                                        onChange={(e) => {
                                            OnChangeName(e);
                                        }}
                                    />
                                    {message.AlternateNum ? <label className="hive-form-mandatory">{message.AlternateNum}</label> : null}
                                    {rejexMessage.AlternateNum ? (
                                        <label className="hive-form-mandatory">{rejexMessage.AlternateNum}</label>
                                    ) : null}
                                </div>
                                <div className="col-md-6 mb-4">
                                    <label htmlFor="dependant-emergency-number" className="form-label hive-form-label">
                                        Emergency Contact Number<span className="hive-form-mandatory">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control hive-form-control"
                                        id="dependant-emergency-number"
                                        aria-describedby="Emergency Contact Number"
                                        placeholder="Enter here"
                                        maxLength={10}
                                        name="EmergencyContactNum"
                                        value={EmployeeInfoData.EmergencyContactNum}
                                        onChange={(e) => {
                                            OnChangeName(e);
                                        }}
                                    />
                                    {message.EmergencyContactNum ? (
                                        <label className="hive-form-mandatory">{message.EmergencyContactNum}</label>
                                    ) : null}
                                    {rejexMessage.EmergencyContactNum ? (
                                        <label className="hive-form-mandatory">{rejexMessage.EmergencyContactNum}</label>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    <div className="modal-footer border-0">
                            <button type="button" className="btn hive-btn-secondary" data-bs-dismiss="modal" onClick={() => cancelClick()}>
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="btn hive-btn-primary"
                                onClick={() => {
                                    submitClick();
                                }}
                                disabled={DisableSubmitBtn}
                            >
                                Update
                            </button>
                        </div>
                </div>
            </div>
        </div>
    );
}


function mapStateToProps(state) {

    return {
        websocket: state.webSocketAPI
    }
}

export default connect(mapStateToProps)(EmployeeInfo)